{
  "Panel Email": "Panel Email",
  "directadmin_email": {
    "0 = Sınırsız": "0 = Sınırsız",
    "Disk Kullanımı": "Disk Kullanımı",
    "Doluluk (%)": "Doluluk (%)",
    "E-posta Adresi": "E-posta Adresi",
    "E-posta Hesapları": "E-posta Hesapları",
    "E-posta hesabı oluşturuldu": "E-posta hesabı oluşturuldu.",
    "En az 6 karakter": "En az 6 karakter",
    "Hesap silindi": "Hesap silindi.",
    "Hiç e-posta hesabı bulunamadı": "Hiç e-posta hesabı bulunamadı.",
    "Kota (0 = Sınırsız)": "Kota (0 = Sınırsız)",
    "Kota (MB)": "Kota (MB)",
    "Kota Düzenle": "Kota Düzenle",
    "Kota Limiti (MB)": "Kota Limiti (MB)",
    "Kota güncellendi": "Kota güncellendi.",
    "Kullanıcı Adı": "Kullanıcı Adı",
    "Kullanım (MB)": "Kullanım (MB)",
    "Limit (MB)": "Limit (MB)",
    "Panel Email": "Panel Email",
    "Silme işlemi başarısız": "Silme işlemi başarısız.",
    "Yeni E-posta Hesabı": "Yeni E-posta Hesabı",
    "Yeni Hesap": "Yeni Hesap",
    "hesabı kalıcı olarak silinecek!": "hesabı kalıcı olarak silinecek!",
    "için Yeni Şifre": "için Yeni Şifre",
    "orn: info": "örn: info",
    "Şifre başarıyla değiştirildi": "Şifre başarıyla değiştirildi.",
    "Şifre en az 6 karakter olmalıdır": "Şifre en az 6 karakter olmalıdır",
    "Bir hata oluştu": "Bir hata oluştu.",
    "Excel hatası: ": "Excel hatası: ",
    "Kullanıcı": "Kullanıcı",
    "Şifre Değiştir": "Şifre Değiştir",
    "Sil": "Sil",
    "İptal": "İptal",
    "Kaydet": "Kaydet",
    "Oluştur": "Oluştur",
    "Silme Onayı": "Silme Onayı",
    "Hayır": "Hayır",
    "Evet, Sil": "Evet, Sil",
    "Değiştir": "Değiştir",
    "ExceleAktar": "Excel'e Aktar",
    "Yükleniyor": "Yükleniyor...",
    "Şifre": "Şifre",
    "Yeni Şifre": "Yeni Şifre",
    "Güncelle": "Güncelle",
    "Emin misiniz?": "Emin misiniz?",
    "Hata oluştu": "Hata oluştu",
    "İşlemler": "İşlemler"
  }
}
